import httpClient from '../../api';
import {
  fetchInitSingle,
  fetchSingle,
  fetchInitCollection,
  fetchCollection,
} from '../store-common';

export default () => ({
  namespaced: true,

  state: () => ({
    vacanciesList: fetchInitSingle(),
    vacancies: fetchInitCollection(),
    vacanciesMetaData: fetchInitSingle(),
  }),

  mutations: {
    setVacanciesList(state, payload) {
      state.vacanciesList = { ...payload };
    },
    setVacancies(state, payload) {
      state.vacancies = { ...payload };
    },
    setVacanciesMetaData(state, payload) {
      state.vacanciesMetaData = { ...payload };
    },
  },

  actions: {
    async fetchVacanciesList(context, id) {
      await fetchSingle(async () => {
        const { data: { data } } = await httpClient.get(`/vacancy_lists/${id}`);
        return data;
      }, context, 'setVacanciesList');
    },
    async fetchVacancies(context, { id, page, perPage }) {
      await fetchCollection(async () => {
        const { data: { data, meta } } = await httpClient.get(`/vacancy_lists/${id}/vacancies/public`, {
          params: {
            page,
            perPage,
          },
        });

        await fetchSingle(async () => meta, context, 'setVacanciesMetaData');
        return data;
      }, context, 'setVacancies');
    },
  },
});
